import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  CircularProgress,
  LinearProgress,
  Link
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  Person,
  AccessTime,
  AutoAwesomeMotion,
  CheckCircle,
  CalendarToday
} from '@mui/icons-material';
import moment from 'moment';
import { useEmbedded } from '../../hooks/useEmbedded';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import LinkIcon from '@mui/icons-material/Link';
import { tokens } from '../../theme';
const SectionPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: tokens.radius.md,
  border: `0.5px solid ${tokens.color.borderTertiary}`,
  backgroundColor: tokens.color.bgPrimary,
}));

const DetailItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  '& .MuiSvgIcon-root': {
    marginRight: theme.spacing(1),
    color: tokens.color.textSecondary,
  },
}));

const AuthorsList = styled(List)(({ theme }) => ({
  padding: 0,
  '& .MuiListItem-root': {
    paddingLeft: 0,
    paddingRight: 0,
  }
}));

const ProgressCircle = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const CircleLabel = styled(Box)(({ theme }) => ({
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const CourseDetails = ({
  course,
  instance,
  instances,
  author,
  additionalAuthors,
  progress,
  enrolled,
  enrolledObj,
  activities,
  attachments,
  job_Aids
 
}) => {
  const formatDate = (dateString) => {
    return dateString ? moment(dateString).format('MMM DD, YYYY') : 'Not specified';
  };

  const isEmbedded = useEmbedded();
  const jobAids = course?.job_aids || [];


  const handleInstanceChange = (event) => {
    const instanceId = event.target.value;
    const pathPrefix = isEmbedded ? '/embed' : '';
    window.location.href = `${pathPrefix}/courses/${course.id}/instance/${instanceId}`;
  };
  /*
  const showProgress = progress && enrolled && instance?.id === enrolledObj?.instance_id;
  if (progress && Array.isArray(activities) && activities.length > 0) {
    progress.progress = Math.round((progress.completed / activities.length) * 100);
  } else if (progress) {
    progress.progress = 0;
  }*/

  const getDisplayLabel = (res) => {
  if (res.name && res.type !== 'url') return res.name;
    if (res.type === 'url' || res.url) {
      try {
        const { hostname } = new URL(res.url);
        return hostname.replace(/^www\./, ''); // e.g. "google.com" instead of "www.google.com"
      } catch {
        return res.url; // fallback if URL parsing fails (malformed url)
      }
    }
    return 'Download File';
  };

  const showProgress = progress && enrolled;

  return (    
    <Box>
      <SectionPaper elevation={0} >
        {showProgress ? (
          <>
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="overline"
                sx={{
                  display: 'block',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  color: tokens.color.textSecondary,
                  mb: 1,
                }}
              >
                Your progress
              </Typography>

              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="h4" sx={{ fontWeight: 700, color: tokens.color.textPrimary }}>
                  {progress.progress}%
                </Typography>
                <Typography variant="body2" sx={{ color: tokens.color.textSecondary }}>
                  {progress.completed} of {activities.length || 0} modules
                </Typography>
              </Box>

              <LinearProgress
                variant="determinate"
                value={progress.progress}
                sx={{
                  height: 8,
                  borderRadius: 3,
                  backgroundColor: tokens.color.bgTertiary,
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: progress.progress >= 100 ? tokens.color.positive : tokens.color.brand,
                  },
                }}
              />
            </Box>
            <Divider sx={{ my: 2 }} />
          </>
        ) : null}

        {course.duration && (
          <DetailItem>
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Typography variant="body2" sx={{ color: tokens.color.textSecondary, fontSize: '13.5px'}}>
                Duration
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 600, color: tokens.color.textPrimary }}>
                {course.duration}
              </Typography>
            </Box>
          </DetailItem>
        )}
        {activities.length && (
          <>
          <DetailItem>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Typography variant="body2" sx={{ color: tokens.color.textSecondary, fontSize: '13.5px' }}>
                Modules
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 600, color: tokens.color.textPrimary }}>
                {activities.length || 0}
              </Typography>
            </Box>
          </DetailItem>
          {/*
          <Divider sx={{ my: 2 }} />
          <DetailItem>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="body2" sx={{ color: tokens.color.textSecondary }}>  
                Finish all {activities.length || 0}  modules to complete this course.
              </Typography>
            </Box>
          </DetailItem> */}
          
          </>
        )}

        {instance?.completion_deadline && (
          <DetailItem>
            <CalendarToday fontSize="small" />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Typography variant="body2" sx={{ color: tokens.color.textSecondary }}>
                Due date
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 600, color: tokens.color.textPrimary }}>
                {moment(instance.completion_deadline).format('D MMM YYYY')}
              </Typography>
            </Box>
          </DetailItem>
        )}
      </SectionPaper>
      
        {/* {instance && (
          <DetailItem>
            <AutoAwesomeMotion fontSize="small" />
            <Box>
              <Typography variant="body2" color="textSecondary">
                Current Instance
              </Typography>
              <Typography variant="body1">
                {instance.title || `Instance ${instance.id}`}
                {instance.default_instance === '1' && (
                  <Chip
                    label="Default"
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{ ml: 1 }}
                  />
                )}
              </Typography>
              {instances && instances.length > 1 && (
                <Link
                  to={`${isEmbedded ? '/embed' : ''}/learner/course/${course.id}/instances`}
                  state={{
                    instances,
                    enrolledInstanceId: enrolledObj?.instance_id,
                    progress,
                    courseId: course.id
                  }}
                  style={{ textDecoration: 'none' }}
                >
                  <Typography variant="body2" color="primary">
                    View All
                  </Typography>
                </Link>
              )}
            </Box>
          </DetailItem>
        )} */}

        {/* <Divider sx={{ my: 2 }} /> */}

        {/* <Typography variant="subtitle1" gutterBottom>
          Authors
        </Typography>

        <AuthorsList>
          {author && (
            <ListItem>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText
                primary={`${author.first_name} ${author.last_name}`}
                secondary="Primary Author"
              />
            </ListItem>
          )}

          {additionalAuthors && Object.keys(additionalAuthors).length > 0 && (
            Object.values(additionalAuthors).map((additionalAuthor) => (
              <ListItem key={additionalAuthor.id}>
                <ListItemIcon>
                  <Person />
                </ListItemIcon>
                <ListItemText
                  primary={`${additionalAuthor.first_name} ${additionalAuthor.last_name}`}
                />
              </ListItem>
            ))
          )}
        </AuthorsList> */}
        
        
      {attachments && attachments.length > 0 && (          
        <SectionPaper elevation={0} >              
          <>
            <Box sx={{ mb: 3 }}>                  
              <Typography
                variant="overline"
                sx={{
                  display: 'block',
                  fontWeight: 700,
                  letterSpacing: '0.08em',
                  color: tokens.color.textSecondary,
                  mb: 1,
                }}
              >
                Resources
              </Typography>

              {attachments.map((res) => (
                <Box>
                  <Link
                    href={res.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      textDecoration: 'none',
                      color: tokens.color.textPrimary,
                      '&:hover': { color: '#E2622C' },
                      fontSize: '13.5px',
                    }}
                  >
                    {getDisplayLabel(res)}
                  </Link>
                </Box>
              ))}
            </Box>
          </>
        </SectionPaper>          
      )}
      {/* <Divider sx={{ my: 2 }} /> */}
      {/* <Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0 }}>
          Job Aids
        </Typography>
        {job_Aids.length > 0 ? (
          <List sx={{ pl: 0 }} dense>
            {job_Aids.map((aid) => (
              <ListItem
                key={aid.id}
                button
                component={Link}
                to={`/job-aids/preview/${aid.id}`}
                target="_blank"
                sx={{ pl: 1 }}
              >
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <InsertDriveFile />
                </ListItemIcon>
                <ListItemText
                  primary={aid.name}
                  secondary={
                    aid.description ? (
                      <span
                        dangerouslySetInnerHTML={{ __html: aid.description }}
                      />
                    ) : null
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body2" color="text.secondary">
            No job aids available.
          </Typography>
        )}
      </Box> */}
    </Box>
  );
};

export default CourseDetails;
